module.exports = __webpack_public_path__ + "static/media/world.2d3ff959.png";